/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import type { Observable } from 'rxjs';
import type { Invoice_Models_Enums_SortOrder } from '../models/Invoice_Models_Enums_SortOrder';
import type { Invoice_Models_Requests_UnmatchedDocumentSortBy } from '../models/Invoice_Models_Requests_UnmatchedDocumentSortBy';
import type { Invoice_Models_UnmatchedSubmissionsDto } from '../models/Invoice_Models_UnmatchedSubmissionsDto';
import { BaseHttpRequest } from '../core/BaseHttpRequest';
@Injectable({
    providedIn: 'root',
})
export class UnmatchedDocumentsService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * Get unmatched documents
     * Get unmatched documents
     * @returns Invoice_Models_UnmatchedSubmissionsDto Success
     * @throws ApiError
     */
    public getApiV2UnmatchedDocument({
        pageNumber,
        searchTerm,
        status,
        containsInvoice,
        uuid,
        pageSize,
        sortBy,
        sortOrder,
    }: {
        /**
         * Page index of the records to return.
         * Default value is 1.
         */
        pageNumber: number,
        /**
         * The search term used for filtering results.
         */
        searchTerm?: string,
        /**
         * The status of the entity.
         */
        status?: string,
        /**
         * Contains invoice?.
         */
        containsInvoice?: boolean,
        /**
         * Contains invoice?.
         */
        uuid?: string,
        /**
         * Number of records per page. Need to set this value in order to get results.
         */
        pageSize?: number,
        /**
         * Property of the entity to sort by.
         * Default value is EmailDate.
         */
        sortBy?: Invoice_Models_Requests_UnmatchedDocumentSortBy,
        /**
         * Sort order.
         * Values: ASC, DESC.
         * Default value is ASC.
         */
        sortOrder?: Invoice_Models_Enums_SortOrder,
    }): Observable<Invoice_Models_UnmatchedSubmissionsDto> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/v2/unmatched-document',
            query: {
                'SearchTerm': searchTerm,
                'Status': status,
                'ContainsInvoice': containsInvoice,
                'Uuid': uuid,
                'PageNumber': pageNumber,
                'PageSize': pageSize,
                'SortBy': sortBy,
                'SortOrder': sortOrder,
            },
        });
    }
}
